<template >
  <div class="o-component m-text">
    <h2 class="a-h3">{{ props.titleText.title }}</h2>
    <section v-html="props.titleText.text"></section>
    <a v-if="(props.titleText.button_text ?? '').length > 0 || (props.titleText.button_url ?? '').length > 0"
      :href="props.titleText.button_url">{{ props.titleText.button_text }}</a>
  </div>
</template>
<script setup lang="ts">
import { PropType } from 'vue';
import { TitleTextBlock } from '../../helper/article';

const props = defineProps({
  titleText: {
    type: Object as PropType<TitleTextBlock>,
    required: true,
  },
})
</script>
